import { SourceType } from 'module/api/filter/types';
import { asUserMetaData } from 'module/helpers/filter/as-user-field-meta';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { camelCase } from 'lodash';
import { useGetAllMeetingFieldsQuery } from 'queries/fields';
import { useGetAllActiveNativeUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export const useMeetingFieldsAsFilterableFields = () => {
  const { data: meetingFields, isLoading } = useGetAllMeetingFieldsQuery();
  const { data: nativeUsers, isLoading: isUserLoading } =
    useGetAllActiveNativeUsersQuery();
  const userMeta = useMemo(() => {
    return asUserMetaData(nativeUsers ?? []);
  }, [nativeUsers]);

  return useMemo(
    () => ({
      loading: isLoading || isUserLoading,
      fields: (
        (meetingFields ?? [])
          .map((field) => ({
            ...field,
            fieldName: camelCase(field.fieldName),
            type: filterableFieldType(field),
            sourceType: SourceType.Meeting,
          }))
          .map((field) =>
            [FieldType.SingleUser, FieldType.MultiUser].includes(field.type)
              ? { ...field, metaData: userMeta }
              : field,
          ) as FilterableField[]
      ).filter((field) => field.isEnabled),
    }),
    [isLoading, isUserLoading, meetingFields, userMeta],
  );
};
